import { getCountriesList } from '@uniqkey-frontend/shared-app';

export const COUNTRIES_LIST = getCountriesList();
export const isCountryValid = (country: string) => COUNTRIES_LIST.includes(country);
